// Angular
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ClienteService } from '../../services/cliente.service';

@Component({
  selector: 'app-seguridad-listado-usuarios',
  templateUrl: './seguridad-listado-usuarios.component.html',
  styleUrls: ['./seguridad-listado-usuarios.component.scss']
})
export class SeguridadListadoUsuariosComponent implements OnInit {
  @Output() selecttab = new EventEmitter<any>();
  constructor(
    private clientService: ClienteService,
  ) { }

  ngOnInit(): void {
  }

  changeMenuModule(tab): void {
    this.selecttab.emit(tab);
  }


}
